import { useEffect, useState } from "react";
// import style from "./reward.module.css";
import singhCoinCurrency from "assets/images/singhCoinCurrency.png";
import { Link, useNavigate } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import { Button, Grid, Typography } from "@mui/material";
import MDTypography from "components/MDTypography";
import { useMediaQuery } from "react-responsive";
import Card from "@mui/material/Card";
import { Divider } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DataTable from "examples/Tables/DataTable";
import earnsinghTable from "layouts/reward/components/earnsinghTable";
import secondsinghTable from "./components/earnsinghTable/secondTable";
import thirdsinghTable from "./components/earnsinghTable/thirdsinghTable";
import { getRewardPointsInfo } from "services/apiService";

const EarnSingh = () => {
  const [reward, setReward] = useState(0);
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(0);
  const [tabsLoader, setTabsLoader] = useState(true);
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const handleSetTabValue = (event, newValue) => setTabValue(newValue);
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const [rewardsInfo, setRewardsInfo] = useState({});

  const { columns, rows } = earnsinghTable(
    rewardsInfo.post,
    rewardsInfo.limitPost,
    rewardsInfo.like,
    rewardsInfo.limitLike,
    rewardsInfo.comment,
    rewardsInfo.limitComment,
    rewardsInfo.engagement,
    rewardsInfo.limitEngagement
  );

  const { columns: pColumns, rows: pRows } = secondsinghTable(
    rewardsInfo.NFT,
    rewardsInfo.limitNFT,
    rewardsInfo.NFTSale,
    rewardsInfo.limitNFTSale
  );

  const { columns: tColumns, rows: tRows } = thirdsinghTable(
    rewardsInfo.singnUp
  );

  useEffect(() => {
    getRewardsInfo();
  }, []);

  const getRewardsInfo = async () => {
    const getRewardPointsInfoRes = await getRewardPointsInfo();
    if (getRewardPointsInfoRes.status === 200) {
      setRewardsInfo(getRewardPointsInfoRes.data);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={12}>
            <Card sx={{ backgroundColor: "#1a1a1a" }}>
              <MDBox
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                mx={2}
                mt={-3}
                sx={{
                  marginTop: "14px",
                  background: "linear-gradient(195deg, #1a1a1a, #08080c)",
                  boxShadow:
                    "0rem 0.25rem 1.25rem 0rem rgba(0, 0, 0, 0.14), 0rem 0.4375rem 0.625rem -0.3125rem rgb(113 113 113 / 40%)",
                }}
                p={2}
                mb={1}
                textAlign="center"
              >
                <MDTypography
                  variant="h5"
                  fontWeight="medium"
                  color="white"
                  mt={1}
                >
                  {/* {userAppInfo?.username} */}
                </MDTypography>
                <MDTypography
                  variant="h6"
                  fontWeight="medium"
                  color="white"
                  mt={1}
                >
                  {/* {userAppInfo?.fullName} */}
                </MDTypography>
                <Grid
                  container
                  spacing={4}
                  justifyContent="center"
                  sx={{ mb: 2 }}
                >
                  <Grid item xs={12} lg={12}>
                    <MDBox sx={{ display: "flex", justifyContent: "center" }}>
                      <MDTypography
                        sx={{ fontSize: "22px", fontWeight: "700" }}
                      >
                        Earn Singh Coins
                      </MDTypography>
                    </MDBox>
                    <MDTypography sx={{ fontSize: "18px", fontWeight: "700" }}>
                      when you perform below actions:
                    </MDTypography>
                  </Grid>
                </Grid>
                <Divider component="li" variant="inset" />
              </MDBox>
              <MDBox sx={{ textAlign: "center" }}>
                <Grid container sx={{ justifyContent: "center" }}>
                  <MDTypography
                    variant="h6"
                    fontWeight="medium"
                    sx={{ fontSize: "20px", color: "#f5d244" }}
                  >
                    Every Time
                  </MDTypography>
                </Grid>
                <Grid item xs={12}>
                  <Card>
                    <MDBox
                      mx={2}
                      mt={-3}
                      py={3}
                      px={2}
                      variant="gradient"
                      borderRadius="lg"
                      coloredShadow="info"
                      sx={{ backgroundColor: "#f5d244" }}
                    >
                      <MDTypography variant="h6" color="white">
                        Every Time
                      </MDTypography>
                    </MDBox>
                    <MDBox pt={3}>
                      <DataTable
                        table={{ columns, rows }}
                        isSorted={false}
                        entriesPerPage={false}
                        showTotalEntries={false}
                        noEndBorder
                      />
                    </MDBox>
                    <MDBox pt={3}>
                      <DataTable
                        table={{ columns: pColumns, rows: pRows }}
                        isSorted={false}
                        entriesPerPage={false}
                        showTotalEntries={false}
                        noEndBorder
                      />
                    </MDBox>
                    <MDBox
                      mx={2}
                      mt={3}
                      py={3}
                      px={2}
                      variant="gradient"
                      borderRadius="lg"
                      coloredShadow="info"
                      sx={{ backgroundColor: "#f5d244" }}
                    >
                      <MDTypography variant="h6" color="white">
                        One Time
                      </MDTypography>
                    </MDBox>
                    <MDBox pt={3}>
                      <DataTable
                        table={{ columns: tColumns, rows: tRows }}
                        isSorted={false}
                        entriesPerPage={false}
                        showTotalEntries={false}
                        noEndBorder
                      />
                    </MDBox>
                  </Card>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};

export default EarnSingh;
